import { c as _c } from "react/compiler-runtime";
import { ArrowRightIcon } from '@radix-ui/react-icons';
import type { Data } from '@repo/strapi-types';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
interface TileLinkProps {
  link?: Data.Component<'utilities.link'> | null;
  className?: string;
}
export function TileLink(t0) {
  const $ = _c(8);
  const {
    link,
    className
  } = t0;
  if (!link?.label) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center justify-start text-left", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== link.label) {
    t2 = <Paragraph fontSize="bodyRegularSmall" className="text-brand-black group-hover:text-brand-salmon">{link.label}</Paragraph>;
    $[2] = link.label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRightIcon className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-2 group-hover:text-brand-salmon" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}